
import { Vue, Component } from "vue-property-decorator";
import { ROOT_MUTATIONS } from "./store/mutations";
import { Snackbar } from "./store/types";
import { USER_ACTIONS } from "./store/user/actions";

import { PARTNER_ACTIONS } from "./store/partner/actions";
import { auth } from "./firebase";
import ConfirmDialog from "@/components/content/ConfirmDialog.vue";

@Component({
  components: {
    Navigation: () => import("@/components/layout/Navigation.vue"),
    ConfirmDialog,
  },
})

export default class App extends Vue {
  loading = true;

  multiFactorEnrollmentDialog = true;

  get backgroundColor(): string {

    return this.$vuetify.theme.dark ? '#1f1f1f' : '#f6f7f9'
  }

  get snackbar(): Snackbar {
    return this.$store.state.snackbar;
  }

  set snackbar(value: Snackbar) {
    this.$store.commit(ROOT_MUTATIONS.TOGGLE_SNACKBAR, value);
  }

  async created() {
    try {
      await this.$store.dispatch(USER_ACTIONS.AUTHENTICATE_USER);

      setTimeout(() => {
        this.loading = false;
      }, 1000);

      await this.$store.dispatch(PARTNER_ACTIONS.LOAD_PARTNERS);

    } catch (error) {
      const whiteListPaths = [
        '/login',
      ]
      // if route is not in white list, redirect to login, and back to the route afterwards
      if (!whiteListPaths.includes(this.$route.path)) {
        this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }

  }

  get authenticated(): boolean {
    return this.$store.state.user.authenticated && !!auth().currentUser;
  }
}
